module.exports = __webpack_public_path__ + "img/2.28a5ea4a.png";